// extracted by mini-css-extract-plugin
export default {"modal":"IssueModal_modal__pvwRP","box":"IssueModal_box__vsERK"};